var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"bg-gray-100 transition-all w-full duration-300 min-h-[calc(100vh-310px)]"},[_c('div',{staticClass:"container mx-auto flex justify-center items-center px-[30px] sm:px-0 h-[calc(100vh-310px)]"},[_c('NotFound',{attrs:{"title":"Halaman tidak ditemukan."}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }